import { CampaignStatus, ProjectPrefixes } from './types';

import config from 'config';

export const isPromoCodesFeatureEnabled = (): boolean => {
    return Boolean(config.PROMO_CODES_ENABLED === 'true');
};

export const CampaignStatusMap: Record<number, CampaignStatus> = {
    1: CampaignStatus.IDLE,
    2: CampaignStatus.ACTIVE,
    3: CampaignStatus.EXPIRED,
};

export const ProjectPrefixMap: Record<number, ProjectPrefixes> = {
    10: ProjectPrefixes.MB,
    18: ProjectPrefixes.WF,
    12: ProjectPrefixes.YG,
};

export const mapStatus = (value: number): CampaignStatus => {
    return CampaignStatusMap[value] ?? CampaignStatus.IDLE;
};
